import { esData } from "./es";
import { enData } from "./en";
import { ptData } from "./pt";
export const MenuTranslation = Object.freeze({
    es: esData,
    en: enData,
    pt: ptData
})